module.exports = __webpack_public_path__ + "img/media (1).aeb3ce84.png";